import { useDemoData } from "@mui/x-data-grid-generator";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const ReturnDataTable = ({ rowLength }: { rowLength?: number }) => {
    const { data, loading } = useDemoData({
        dataSet: "Commodity",
        rowLength: rowLength ? rowLength : 10,
        maxColumns: 6,
    });

    return (
        <>
            {(!loading && (
                <DataGrid
                    {...data}
                    density="standard"
                    loading={loading}
                    slots={{ toolbar: GridToolbar }}
                    sx={{
                        padding: "10px",
                    }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                        },
                    }}
                />
            )) || <div>Loading.......</div>}
        </>
    );
};

export default ReturnDataTable;
